<div class="start_container">
  <div class="center_column">
    <div class="banner_column">
      {{'registrierung.start.willkommen' | translate}}
    </div>

    <div class="illustration_background">
      <img ngSrc="/assets/illustration_hello.svg" alt="Hallo" width="172" height="128" priority/>
    </div>

    <div class="banner_column_small">
      {{'registrierung.start.vier_schritte' | translate}}
    </div>
  </div>

  <div class="register_button_container">
    <button routerLink="/registrierung" mat-flat-button color="primary" style="width: 100%" class="call-to-action" >
      {{'registrierung.start.registrieren' | translate}}
    </button>
  </div>
</div>
